/*
 *@Description:系统初始化加载
 *@Author: zhengff
 *@Date: 2019-04-21 22:52:37
 */
import utils, { Bus } from "$utils";
import { api } from "@src/common/api";
// import {Dic} from '@src/common/config/dictionary'
import store from "@src/common/lib/store";

const SYS_START = {
  /*
   *@name:init
   *@param:{type}
   *@description:系统初始化加载方法
   *@return:无
   *@author: zhengff
   *@date: 2019-04-21 22:53:00
   */
  init() {
    // OCX组件加载
    // SYS_START.initOCX.apply(this);
  },
  /*
   *@name:initOCX
   *@param:{type} 无
   *@description:加载OCX对象
   *@return:
   *@author: zhengff
   *@date: 2019-04-21 22:53:42
   */
  initOCX() {
    // const self = this;
    // // 寄宿于全局环境window下
    // Object.defineProperty(window, '$OCX', {
    //     get() {
    //         return self.$refs.ocxComponent
    //     }
    // });
  },
  /**
   *@name:getDics
   *@param:{type} 无
   *@description:获取系统全部数据字典
   *@return: 无
   *@author: zgguc
   *@date: 2019-04-23
   */
  initDic() {
    // step1 :加载静态字典
    // const staticDic = []
    // utils.Cache.put('SYS_DIC', staticDic)
    // step2 :加载后端字典
    const self = this;
    return self.$fetch(api.common.getDics).then((res) => {
      if (res && res.success) {
        if (res.returnObj && res.returnObj.length) {
          const sysDic = utils.Cache.get("SYS_DIC");
          // console.log(sysDic);
          // var newDic = sysDic.concat()
          // //或者使用slice()复制，var arr = arr1.slice(0)
          // for (var i = 0; i < res.returnObj.length; i++) {
          //   newDic.indexOf(res.returnObj[i]) === -1 ? newDic.push(res.returnObj[i]) : 0
          // }
          // utils.Cache.put('SYS_DIC', newDic)
          utils.Cache.put("SYS_DIC", []);
          let newDic = JSON.parse(JSON.stringify(res.returnObj));
          utils.Cache.put("SYS_DIC", newDic);
        } else {
          utils.Log.warn("数据字典加载失败！");
        }
      }
    });
  },
  getUserLoginInfo() {
    const self = this;
    return self
      .$fetch("cms/account/queryLoginAccountInfo.json")
      .then((response) => {
        const data = response.returnObj;
        const userInfoFromCache = store.getters.userInfo;
        const currentTheme = store.getters.currentTheme;
        let avatarImg = "";
        delete data.accountNumber;
        if (data.fileCode) {
          avatarImg = Bus.imgPath(data.fileCode);
        } else {
          if (data.sex === 0) {
            avatarImg = `./images/theme/${currentTheme}/photo-women.png`;
          } else {
            avatarImg = `./images/theme/${currentTheme}/photo.png`;
          }
        }
        data.avatarImg = avatarImg;
        if (userInfoFromCache) {
          this.$store.dispatch(
            "loginSuccess",
            Object.assign({}, userInfoFromCache, data)
          );
        }
        // const userInfoFromCache = store.getters('')
      });
  },
  /*
   *@name:startHeart
   *@param:{type} 无
   *@description: 启动心跳模式
   *@return:无
   *@author: zhengff
   *@date: 2019-04-21 22:54:11
   */
  startHeart() {
    const self = this;
    let time = 5;
    const options = utils.Cache.get("COMMON_OPTIONS");

    if (options && options.heartTimer) time = options.heartTimer;

    // 1000*60*10
    window.heartTimer = setInterval(() => {
      utils.Log.debug("开始定时N分钟心跳执行一次=>" + time);
      const { access_token } = utils.Cache.get("CACHE_USER_INFO");
      self
        .$fetch(api.user.heart + `?token=${access_token}`)
        .then((response) => {
          utils.Log.debug("心跳状态==>", response.success);
        });
    }, 1000 * 60 * time);
  },
  /*
   *@name:stopHeart
   *@param:{type} 无
   *@description:停止心跳模式
   *@return: 无
   *@author: zhengff
   *@date: 2019-04-21 22:54:54
   */
  stopHeart() {
    clearInterval(window.heartTimer);
    window.heartTimer = null;
    utils.Log.debug("停止心跳系统.");
  }
};
export default SYS_START;
